import tools from "tools";
import videojs from "video.js";
import  "videojs-flash";
export default async function parser(options) {
  const type = "application/x-mpegURL";
  let techOrder = ["Html5"];
  let { cssLinks } = options;

  if (options.plugins.videojs_playlist) {
    options.autoplay = false;
  }
  if (options.token) {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", options.token.url, false);
    xhr.send(null);
    if (xhr.response) {
      options.src = `${options.src}?${xhr.response}`;
    }
  }

  /*
  * Browsers
  */
  const browsers = tools.browsers();

  if ((browsers.edge || browsers.safari) && options.EBLib) {
    options.EBLib.statsOnly = true;
  }
  const styleMSfix = () => {
    try {
      tools.addCSS(
        `vjs-style-${options.playerID}-Edge`,
        `#${options.playerID}-player_Flash_api{display: none !important;}`,
      );
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warning(e);
    }
  };

  if (browsers.edge) {
    styleMSfix();
  }
  // IE 9 10 11
  if ((browsers.ms || typeof browsers.msie === "number") && !browsers.edge) {
    console.log("EBLib disabled");
    options.EBLib = false;
    if (options.radio) {
      setTimeout(() => {
        styleMSfix();
      }, 1500);
    }
  }
  // most likely windows <= 7 and IE, and ffx on winxp (no h264 decoder)
  var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
  // console.log(iOS);
  // console.log(browsers.msie);
  // console.log("Window.MediaSource", window.MediaSource)
  if ((browsers.ms && browsers.msie <= 11 && !browsers.edge) ) {
    // console.log("Inside flash code")
    // console.log(browsers.msie);
    cssLinks = ["//libs.easybroadcast.io/css/video-js.min.css"];
    // if (cssLinks) {
    //   console.log('CSS loaded');
    // }
    options.flash = {
      enable: true,
      // swf:
      // 'http://unpkg.com/videojs-swf@5.4.1/dist/video-js.swf',
    };
    // console.log(options.flash);
    options.plugins.videojs_dvrseekbar = false;
    // options.oldVjs = true;
    options.newTech = "contrib-hls";
    techOrder = ["flash"];
  } else if (iOS === true) {
    // console.log("I am here");
    options.tech = "safari";
  }
  // else {
  //   techOrder = ["Html5"];
  // }
  // if (
  //   (options.tech === "hlsjs" && (options.flash || window.MediaSource === undefined)) ||
  //   !document.createElement("video").canPlayType("video/mp4") // no h264 decoder, will fallback to flash
  // ) {
  //   console.log("No decoders found");
  //   options.plugins.videojs_quality_selection = false;
  //   console.log("test");
  //   if (
  //     (typeof browsers.msie === "number" && browsers.msie <= 11) ||
  //     !window.MediaSource
  //   ) {
  //     console.log(browsers.msie);
  //     cssLinks = ["//libs.easybroadcast.io/css/video-js.min.css"];
  //     // if (cssLinks) {
  //     //   console.log('CSS loaded');
  //     // }
  //     options.flash = {
  //       enable: true,
  //       // swf:
  //       // 'http://unpkg.com/videojs-swf@5.4.1/dist/video-js.swf',
  //     };
  //     console.log(options.flash);
  //     options.plugins.videojs_dvrseekbar = false;
  //     // options.oldVjs = true;
  //     options.newTech = "contrib-hls";
  //     techOrder = ["flash"];
  //   //   await tools.loadFile(
  //   //     "https://unpkg.com/videojs-flash/dist/videojs-flash.js",
  //   //   "script",
  //   //   "head",
  //   // );
  //     // console.log(videojs.getTech('Flash'));
  //     // console.log(videojs.getTech('Flash'));
      
      
  //   } else {
  //     console.log("no MediaSource");
  //     techOrder.push("flash");
  //     options.newTech = "contrib-hls";
  //     options.flash = {
  //       enable: true,
  //       swf:
  //         "https://cdnjs.cloudflare.com/ajax/libs/videojs-swf/5.4.1/video-js.swf",
  //     };
  //   } 
  // } else if (browsers.msie <= 11) {
  //   techOrder = ["flash"]
  //     options.newTech = "contrib-hls";
  //     options.flash = {
  //       enable: true,
  //       swf:
  //         "https://cdnjs.cloudflare.com/ajax/libs/videojs-swf/5.4.1/video-js.swf",
  //   };
  // }

  if (!options.simple) {
    await Promise.all(
      cssLinks.map(link => tools.loadFile(link, "link", "head")),
    );
  } else {
    options.autoplay = false;
    options.controls = false;
    options.preload = false;
  }
  if (options.files) {
    options.files.forEach(e => {
      tools.loadFile(e.link, e.type, e.tag || "body");
    });
  }
  if (options.css) {
    tools.addCSS(options.playerID, options.css);
  }
  // if (options) {
  //   console.log("Options",options)
  // }
  return {
    tech: "hlsjs",
    controlBar: true,
    autoplay: true,
    simple: false,
    radio: false,
    large: false,
    techOrder,
    browsers,
    preload: "auto",
    hls: {
      withCredentials: false,
    },
    type,
    ...options,
  };
}



// WEBPACK FOOTER //
// ./src/js/parseConfig.js